import http from '@/api/base'

// 查询房间可用时间
const checkAvailable = (params) => {
  if (process.env.NODE_ENV === 'development') {
    return http.post('/contract/checkAvailable', params)
  } else {
    return http.post('/dcits-consumption/contract/checkAvailable', params)
  }
}

// 增加公寓价格信息
const addEstateRoomPrice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    return http.post('/estateRoomPrice/add', params)
  } else {
    return http.post('/dcits-consumption/estateRoomPrice/add', params)
  }
}

// 修改公寓价格信息
const updateEstateRoomPrice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    return http.post('/estateRoomPrice/update', params)
  } else {
    return http.post('/dcits-consumption/estateRoomPrice/update', params)
  }
}

// 删除公寓价格信息
const deleteEstateRoomPrice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    return http.delete('/estateRoomPrice/del/' + params)
  } else {
    return http.delete('/dcits-consumption/estateRoomPrice/del/' + params)
  }
}

// 查询公寓价格信息
const listEstateRoomPrice = (params) => {
  if (process.env.NODE_ENV === 'development') {
    return http.get('/estateRoomPrice/list', params)
  } else {
    return http.get('/dcits-consumption/estateRoomPrice/list', params)
  }
}

// 查询公寓价格信息
const queryEstateRoomPrice = (params, current, size) => {
  if (process.env.NODE_ENV === 'development') {
    return http.post(`/estateRoomPrice/query?current=${current}&size=${size}`, params)
  } else {
    return http.post(`/dcits-consumption/estateRoomPrice/query?current=${current}&size=${size}`, params)
  }
}

// 保存物业合同的收款单位信息
const addPropertyContractAccountCompany = (params) => {
  if (process.env.NODE_ENV === 'development') {
    return http.post(`/contract/addPropertyContractAccountCompany`, params)
  } else {
    return http.post(`/dcits-consumption/contract/addPropertyContractAccountCompany`, params)
  }
}

// 查询物业合同的收款单位信息
const queryPropertyContractAccountCompany = (contractId) => {
  if (process.env.NODE_ENV === 'development') {
    return http.get(`/contract/queryPropertyContractAccountCompany?contractId=${contractId}`)
  } else {
    return http.get(`/dcits-consumption/contract/queryPropertyContractAccountCompany?contractId=${contractId}`)
  }
}

export default {
  checkAvailable,
  addEstateRoomPrice,
  updateEstateRoomPrice,
  deleteEstateRoomPrice,
  listEstateRoomPrice,
  queryEstateRoomPrice,
  addPropertyContractAccountCompany,
  queryPropertyContractAccountCompany
}



// WEBPACK FOOTER //
// ./src/area-dcits/api/dcitsContract.js